import React from 'react'
import { Link } from 'react-router-dom'
import { FiMail, FiPhone, FiMapPin } from "react-icons/fi"

import Logo from '../../images/logo.png'

const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const Footer = () => {
    return (
        <footer className="wpo-site-footer">

            {/* ================= UPPER FOOTER ================= */}
            <div className="wpo-upper-footer">
                <div className="container-fluid">
                    <div className="row">

                        {/* ABOUT */}
                        <div className="col col-lg-4 col-md-6 col-12">
                            <div className="widget about-widget">
                                <div className="logo widget-title">
                                    <img src={Logo} alt="logo" />
                                </div>
                                <p>
                                    Empowering your property decisions with clarity and trust.
                                    Your vision, our commitment.
                                </p>
                            </div>
                        </div>

                        {/* CONTACT */}
                        <div className="col col-lg-5 col-md-6 col-12">
                            <div className="widget link-widget">
                                <div className="widget-title">
                                    <h3>Contact</h3>
                                </div>

                                <ul className="contact-list">

                                    <li>
                                        <FiMail className="footer-icon" />
                                        <span>luxrock.realty@gmail.com</span>
                                    </li>

                                    <li>
                                        <FiPhone className="footer-icon" />
                                        <span>+91 98985 43245</span>
                                    </li>

                                    <li>
                                        <FiMapPin className="footer-icon" />
                                        <span>
                                            432, Gala Empire, Nr. Drive In Road,
                                            Opp. T.V Tower, Thaltej, Ahmedabad - 380054
                                        </span>
                                    </li>
                                    <div className="rera-box">
                                        <span>RERA Registered</span>

                                        <span>
                                            AG/GJ/AHMEDABAD/AHMEDABAD CITY/AA05946/190730R1
                                        </span>
                                    </div>
                                </ul>
                            </div>
                        </div>

                        {/* QUICK LINKS */}
                        <div className="col col-lg-3 col-md-6 col-12">
                            <div className="widget link-widget">
                                <div className="widget-title">
                                    <h3>Quick Link</h3>
                                </div>
                                <ul>
                                    <li><Link onClick={ClickHandler} to="/aboutus">About Us</Link></li>
                                    <li><Link onClick={ClickHandler} to="/our-services">Services</Link></li>
                                    <li><Link onClick={ClickHandler} to="/our-projects">Projects</Link></li>
                                    <li><Link onClick={ClickHandler} to="/our-blogs">Blog</Link></li>
                                    <li><Link onClick={ClickHandler} to="/contact-us">Contact</Link></li>

                                </ul>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            {/* ================= LOWER FOOTER ================= */}
            <div className="p-0 wpo-lower-footer ">
                <div className="container-fluid">
                    <div className="row g-0 align-items-center">

                        <div className="col-lg-6 col-12">
                            <p className="copyright">
                                Copyright © 2026 Luxrock. All Rights Reserved.
                            </p>
                        </div>

                        <div className="col-lg-6 col-12 text-lg-end">
                            <ul className="right">
                                <li><Link to="/privace">Privacy & Policy</Link></li>
                                <li><Link to="/terms">Terms</Link></li>
                                <li><Link to="/aboutus">About us</Link></li>
                            </ul>
                        </div>

                    </div>

                    {/* CREDIT LINE */}
                    <div className="footer-credit text-center ">
                        <p>
                            Designed & Developed by-
                            <a href='https://www.webtekinc.com/'>
                                <strong>
                                    Webtek Digital pvt.ltd.
                                </strong>
                            </a>

                        </p>
                    </div>

                </div>
            </div>

        </footer>
    )
}

export default Footer
